{
  "steplist": "Lista de pași"
}
